"use strict";

;
(function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);

  /**
   * Check if this ad should be shown
   * @returns boolean
   */
  function isEnabled() {
    return Flix.ads.enabled && !Flix.ads.isOrganic(); // do not show for organic users
  }
  ;

  /**
   * Main logic
   */
  function onPageLoad() {
    if (!isEnabled()) {
      return;
    }
    if (Flix.isTna()) {
      // mobile only
      if (!FlixUtils.isMobile()) {
        return;
      }
      var s = document.createElement('script');
      s.src = '//cdn.tapioni.com/asg_embed.js';
      s.type = 'text/javascript';
      s.async = true;
      s.setAttribute('data-tag', 'asg');
      s.setAttribute('data-spots', '350755');
      s.setAttribute('data-subid1', Flix.ads.iid);
      document.body.appendChild(s);
    } else {
      // This script might be added in fpi.js as well
      if (!document.querySelector('[data-guid="659b7459-5a4c-4529-b17c-06eafc6bea53"]')) {
        var s = document.createElement('script');
        s.type = "text/javascript";
        s.src = "https://cdn.twinrdsrv.com/Scripts/infinity.js.aspx?guid=659b7459-5a4c-4529-b17c-06eafc6bea53&tid=".concat(Flix.ads.iid);
        s.id = 'infinity';
        s.async = true;
        s.setAttribute("data-guid", "659b7459-5a4c-4529-b17c-06eafc6bea53");
        s.setAttribute("data-version", "async");
        s.setAttribute("data-tid", Flix.ads.iid);
        document.head.appendChild(s);
      }
    }
  }
  ;
})();